import { render, staticRenderFns } from "./chuku_add.vue?vue&type=template&id=0d470ff1&scoped=true"
import script from "./chuku_add.vue?vue&type=script&lang=js"
export * from "./chuku_add.vue?vue&type=script&lang=js"
import style0 from "./chuku_add.vue?vue&type=style&index=0&id=0d470ff1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d470ff1",
  null
  
)

export default component.exports